module.exports = __webpack_public_path__ + "liechtenstein.svg?71e792cf9b52668237b3f3acafe1980c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/liechtenstein.svg
// module id = 215
// module chunks = 10